import apiClient from 'apiClient';
import { AxiosResponse } from 'axios';
import { ProductCode } from 'domain/Product';
import { CaseDetails } from 'modules/cm/pages/CaseDetailsPage/CaseDetailsPage.types';
import { Product as APIProduct } from '../types';

type TermLengths = CaseDetails['resources']['productTermLengths'];

interface Product extends APIProduct {
  productCode: ProductCode;
}

interface Response
  extends AxiosResponse<{
    product: Product;
    productTermLengths: TermLengths;
  }> {}

const changeProduct = (endpoint: string) => (productCode: ProductCode): Promise<Response['data']> => {
  return apiClient
    .post<any, Response>(`${endpoint}/switch-product`, { code: productCode })
    .then(({ data }) => data);
};

export default changeProduct;
